import React, { type Dispatch, type SetStateAction } from 'react';
import { Typography, Box, Paper } from '@mui/material';
import SystemAccordionList from '../SystemAccordionList';
import HvacSystemFields, { defaultHvacSystem } from '../HvacSystemFields';
import type { HvacSystemValues } from '../HvacSystemFields';
import MediaUploadSection from '../../../../sharedModules/mediaUpload/MediaUploadSection';
import type { ManufacturerOption } from '../../hooks/useHomeServiceManufacturers';
import { sectionHeaderSx } from './inspectionReportFormStyles';

interface HvacInspectionSectionProps {
  hvacSystems: HvacSystemValues[];
  setHvacSystemsWithDirty: Dispatch<SetStateAction<HvacSystemValues[]>>;
  hvacManufacturers: ManufacturerOption[];
  hvacSystemPhotos: File[][];
  updateSystemPhotos: (type: 'hvac' | 'plumbing', index: number, files: File[]) => void;
}

const HvacInspectionSection: React.FC<HvacInspectionSectionProps> = ({
  hvacSystems,
  setHvacSystemsWithDirty,
  hvacManufacturers,
  hvacSystemPhotos,
  updateSystemPhotos,
}) => (
  <Paper variant="outlined" sx={{ mb: 3, overflow: 'hidden' }}>
    <Typography sx={sectionHeaderSx}>HVAC</Typography>
    <Box sx={{ p: 2 }}>
      <SystemAccordionList<HvacSystemValues>
        sectionLabel="HVAC"
        systems={hvacSystems}
        onSystemsChange={setHvacSystemsWithDirty}
        defaultSystem={defaultHvacSystem}
        renderFields={(sys, idx, onChange) => (
          <>
            <HvacSystemFields values={sys} onChange={onChange} manufacturers={hvacManufacturers} />
            <MediaUploadSection
              label={`HVAC ${idx + 1} Photos`}
              files={hvacSystemPhotos[idx] || []}
              onChange={(files) => updateSystemPhotos('hvac', idx, files)}
            />
          </>
        )}
      />
    </Box>
  </Paper>
);

export default HvacInspectionSection;
